export const checkoutQueryKeys = {
  all: ["checkout"] as const,
  writes: ["checkoutWrite"] as const,
  checkout: (cartId?: string) => ["checkout", cartId] as const,
  delivery: (cartId: string | undefined, zipCode: string, cartTotal: number) =>
    ["checkoutDelivery", cartId, zipCode, cartTotal] as const,
  deliveries: (locale: string) => ["checkoutDeliveries", locale] as const,
  walleyForm: (cartId: string | undefined, paymentType: string) =>
    ["walleyForm", cartId, paymentType] as const,
  adyenForm: (cartId: string | undefined, cartTotal: number) =>
    ["adyenForm", cartId, cartTotal] as const,
  buyer: (zipCode?: string) =>
    ["checkoutWrite", "buyer", zipCode] as const,
  receiver: (zipCode?: string) =>
    ["checkoutWrite", "receiver", zipCode] as const,
  deliveryOption: ["checkoutWrite", "deliveryOption"] as const,
  cartItem: ["checkoutWrite", "cartItem"] as const,
  promotion: ["checkoutWrite", "promotion"] as const,
  metadata: ["checkoutWrite", "metadata"] as const,
  method: ["checkoutWrite", "method"] as const,
};
